import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../components/home/HomeView.vue'
import ExplorerView from '../components/explorer/ExplorerView.vue'
import AccessibilityView from '../components/accessibility/AccessibilityView.vue'
import DownloadsView from '../components/downloads/DownloadsView.vue'
import AboutView from '../components/about/AboutView.vue'
import OverviewView from '../components/about/overview/OverviewView.vue'
import UpdatesView from '../components/about/UpdatesView.vue'
import TutorialsView from '../components/about/TutorialsView.vue'
import ContactView from '../components/about/ContactView.vue'

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
	routes: [	
		{
			path: '/',
			name: 'HomeView',
			component: HomeView,
		},
		{
			path: '/indicatorsexplorer',
			name: 'ExplorerView',
			component: ExplorerView,
			meta: { needsContainPaint: true } // limits height of body
		},
		{
			path: '/accessibility',
			name: 'Accessibility',
			component: AccessibilityView,
		},	
		{
			path: '/downloads',
			name: 'Downloads',
			component: DownloadsView,
		},			
		{
			path: '/about',
			name: 'AboutView',
			component: AboutView,
			children: [
				{
					path: 'overview',
					name: 'OverviewView',
					component: OverviewView,
				},
				{
					path: 'updates',
					name: 'UpdatesView',
					component: UpdatesView,
				},
				{
					path: 'tutorials',
					name: 'TutorialsView',
					component: TutorialsView,
				},
				{
					path: 'contact',
					name: 'ContactView',
					component: ContactView,
				}
			]
		}
	],
	scrollBehavior(to, from, savedPosition) {
		if (to.hash) {
		return {
			el: to.hash,
			behavior: 'smooth', // Optional: adds smooth scrolling
		};
		} else {
		// Optional: scroll to top for normal route changes
		return { top: 0 };
		}
	}
})

router.beforeEach((to, from) => {
	// 'to' is the target RouteLocationNormalized
	// 'from' is the current RouteLocationNormalized
	// 'next' is a function that must be called to resolve the hook
	//console.log('Navigating from:', from.fullPath, 'to:', to.fullPath);
	// Perform actions before the new page component is rendered
	//next(); // Important: call next() to proceed with navigation
	return true;
})

router.afterEach((to) => {
  if (to.meta.needsContainPaint) {
    document.body.classList.add('enable-containment');
  } else {
    document.body.classList.remove('enable-containment');
  }
});

export default router
